import {
  OPEN_PANEL, CLOSE_PANEL, FOCUS_RESTORED, SET_SIDEBAR_WIDTH,
} from './types';
import {
  findPanel, findNextPanel, findVisibleGroup,
} from './sidebarUtils';
import { getSideBarWidth } from '../../client/utils/clientInspectionUtils';

export function openPanel(group, type, options) {
  return {
    type: OPEN_PANEL,
    payload: {
      group,
      type,
      options,
    },
  };
}

export function closePanel(panel) {
  return {
    type: CLOSE_PANEL,
    payload: {
      group: panel.group,
      panel,
    },
  };
}

export function setSidebarWidth(position) {
  return {
    type: SET_SIDEBAR_WIDTH,
    payload: {
      updatedPosition: position,
    },
  };
}

export const closeNextPanel = panel => (dispatch, getState) => {
  const nextPanel = findNextPanel(getState(), panel);
  if (nextPanel) {
    dispatch(closePanel(nextPanel));
  }
};

export const closePanelByType = (group, type) => (dispatch, getState) => {
  const panel = findPanel(getState(), group, type);
  dispatch(closePanel(panel));
};

export const closeAllPanels = () => (dispatch, getState) => {
  const group = findVisibleGroup(getState());
  if (group) {
    const { panels, config: { pinFirstPanel } } = group;
    const panelIndex = panels.length > 1 && pinFirstPanel ? 1 : 0;
    dispatch(closePanel(panels[panelIndex]));
  }
};

export const focusRestored = () => ({ type: FOCUS_RESTORED });

export const updateSidebarWidth = () => (dispatch) => {
  const sidebar = document.querySelector('.sidebar');
  const breakpoint = window.matchMedia(
    'only screen and (min-width: 576px) and (max-width: 1440px)',
  );

  const listener = () => {
    const sidebarWidth = getSideBarWidth();

    if (sidebar) {
      dispatch(setSidebarWidth(sidebarWidth));
    }
  };

  listener();

  /* This is basically an alias for EventTarget.addEventListener(),
  * for backwards compatibility purposes.
  * Older browsers should use addListener instead of addEventListener
  * since MediaQueryList only inherits from EventTarget in newer browsers. */

  breakpoint.addListener(listener);
};
